import _objectSpread from "@babel/runtime/helpers/objectSpread";
import styled from 'styled-components';
import ButtonBase, { buttonTextColor, buttonHoverStyle, buttonActiveStyle, buttonDisabledStyle, buttonFontSize, FONT_WEIGHT } from '../ButtonBase';
import { transitionSpeed } from '../../../styles/animation';
export var ButtonStyled = styled.button(function (props) {
  return _objectSpread({}, ButtonBase(props), {
    color: buttonTextColor(props.typeStyle, props.color),
    cursor: 'pointer',
    display: 'inline-flex',
    verticalAlign: 'top',
    justifyContent: 'center',
    outline: 'none',
    fontSize: "".concat(buttonFontSize(props.size), "px"),
    fontWeight: FONT_WEIGHT,
    transition: "all ".concat(transitionSpeed, " ease-in-out"),
    '&[disabled]': _objectSpread({}, buttonDisabledStyle(props.typeStyle), {
      cursor: 'default'
    }),
    '&:not([disabled])': {
      '&:hover, &:focus, &.docz-hover-focus': _objectSpread({}, buttonHoverStyle(props.typeStyle)),
      '&:active, &.docz-active': _objectSpread({}, buttonActiveStyle(props.typeStyle))
    }
  });
});
export var ButtonContent = styled.span({
  '&:not(:only-child)': {
    display: 'inline-block',
    marginLeft: '6px'
  }
});
export var NoWrap = styled.span({
  alignItems: 'center',
  display: 'inline-flex',
  whiteSpace: 'nowrap'
});